// use-fetch-data.js
import { useEffect, useState } from "react";
import { GET_WORKERS_ACCOUNTANT } from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

interface MembersOfReqWork {
  name: string;
  role: string;
  level: number;
  id: number;
}

interface MembersOfReqWorks {
  workers: MembersOfReqWork[];
}

let val: MembersOfReqWorks;

const useFetchData = () => {
  const [data, setData] = useState(val);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await api.get(GET_WORKERS_ACCOUNTANT, null).then((response) => {
          setData(JSON.parse(JSON.stringify(response)));
          setLoading(false);
        });
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return {
    data,
    loading,
  };
};

export default useFetchData;
